import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ProductsService, UploadService } from '../../../../services';
import { ProductInternalResponseDto, ProductNodeDto } from '@scip/api';
import { filter, takeUntil } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs';

@Component({
  selector: 'scip-product-declaration',
  templateUrl: './product-declaration.component.html',
  styleUrls: ['./product-declaration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductDeclarationComponent implements OnInit, OnDestroy {
  @Input() product: ProductInternalResponseDto;

  selectedNodeIdentifier: string;

  rootProductNodeDto: ProductNodeDto;

  productForDossierSummary: ProductInternalResponseDto;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(private productService: ProductsService, private uploadService: UploadService) {}

  ngOnInit(): void {
    this.productForDossierSummary = { ...this.product };
    this.uploadService.uploadProductEmitter
      .pipe(
        filter((data) => data.identifier === this.productForDossierSummary.identifier),
        takeUntil(this.destroyed$)
      )
      .subscribe((data) => (this.productForDossierSummary = data));
  }

  handleNodeIdentifierSelected(selectedNodeIdentifier: string): void {
    if (!this.rootProductNodeDto) {
      this.rootProductNodeDto = this.productService.getRecentProductNodeForSelector(`${this.product.id}`, selectedNodeIdentifier);
    }

    this.selectedNodeIdentifier = selectedNodeIdentifier;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
